// Remote config — reads from the settings/remoteConfig row in Supabase.
// Replaces Firebase Remote Config. Same context API; nothing else changes.
import { createContext, useContext, useEffect, useState } from "react";
import { supabase, supabaseReady } from "@/lib/firebase";

const DEFAULTS = {
  enableAdminAndCustomerFlows: "",
  enableAdmin: "",
};

const RemoteConfigCtx = createContext(DEFAULTS);

export const RemoteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(DEFAULTS);

  useEffect(() => {
    if (!supabaseReady) return;

    // Initial fetch
    supabase
      .from("settings")
      .select("data")
      .eq("name", "remoteConfig")
      .single()
      .then(({ data }) => {
        if (data?.data) setConfig({ ...DEFAULTS, ...data.data });
      });

    // Real-time updates when admin changes the config
    const channel = supabase
      .channel("remote-config")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "settings", filter: "name=eq.remoteConfig" },
        (payload) => {
          if (payload.new?.data) setConfig({ ...DEFAULTS, ...payload.new.data });
        }
      )
      .subscribe();

    return () => supabase.removeChannel(channel);
  }, []);

  return (
    <RemoteConfigCtx.Provider value={config}>
      {children}
    </RemoteConfigCtx.Provider>
  );
};

export const useRemoteConfig = () => useContext(RemoteConfigCtx);
